import React from 'react';

export default class ExternalNeighborhoodChart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {           
            graphYears: "1"
        }
    }
    render(){

        const { graphYears } = this.state;
        const { neighborhoodObj } = this.props;

        var medianSalesPriceData = null;
        var newListingsData = null;
        var homesForSaleData = null;

        var swidth = 570;  
        if(window.innerWidth < 1200 && window.innerWidth >= 1000){
          swidth = 480;
        }
        else if(window.innerWidth < 1000){
          swidth = (window.innerWidth - 30);
        }

        if(graphYears && graphYears === "1"){
          medianSalesPriceData = (neighborhoodObj && neighborhoodObj.MedianSalesPrice1YearLink  && neighborhoodObj.MedianSalesPrice1YearLink !== "") ? neighborhoodObj.MedianSalesPrice1YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          newListingsData = (neighborhoodObj && neighborhoodObj.NewListings1YearLink  && neighborhoodObj.NewListings1YearLink !== "") ? neighborhoodObj.NewListings1YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          homesForSaleData = (neighborhoodObj && neighborhoodObj.HomesForSale1YearLink  && neighborhoodObj.HomesForSale1YearLink !== "") ? neighborhoodObj.HomesForSale1YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
        }
        else if(graphYears && graphYears === "3"){
          medianSalesPriceData = (neighborhoodObj && neighborhoodObj.MedianSalesPrice3YearLink  && neighborhoodObj.MedianSalesPrice3YearLink !== "") ? neighborhoodObj.MedianSalesPrice3YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          newListingsData = (neighborhoodObj && neighborhoodObj.NewListings3YearLink  && neighborhoodObj.NewListings3YearLink !== "") ? neighborhoodObj.NewListings3YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          homesForSaleData = (neighborhoodObj && neighborhoodObj.HomesForSale3YearLink  && neighborhoodObj.HomesForSale3YearLink !== "") ? neighborhoodObj.HomesForSale3YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
        }
        else if(graphYears && graphYears === "5"){
          medianSalesPriceData = (neighborhoodObj && neighborhoodObj.MedianSalesPrice5YearLink  && neighborhoodObj.MedianSalesPrice5YearLink !== "") ? neighborhoodObj.MedianSalesPrice5YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          newListingsData = (neighborhoodObj && neighborhoodObj.NewListings5YearLink  && neighborhoodObj.NewListings5YearLink !== "") ? neighborhoodObj.NewListings5YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          homesForSaleData = (neighborhoodObj && neighborhoodObj.HomesForSale5YearLink  && neighborhoodObj.HomesForSale5YearLink !== "") ? neighborhoodObj.HomesForSale5YearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
        }
        else if(graphYears && graphYears === "max"){
          medianSalesPriceData = (neighborhoodObj && neighborhoodObj.MedianSalesPriceMaxYearLink  && neighborhoodObj.MedianSalesPriceMaxYearLink !== "") ? neighborhoodObj.MedianSalesPriceMaxYearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          newListingsData = (neighborhoodObj && neighborhoodObj.NewListingsMaxYearLink  && neighborhoodObj.NewListingsMaxYearLink !== "") ? neighborhoodObj.NewListingsMaxYearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
          homesForSaleData = (neighborhoodObj && neighborhoodObj.HomesForSaleMaxYearLink  && neighborhoodObj.HomesForSaleMaxYearLink !== "") ? neighborhoodObj.HomesForSaleMaxYearLink.replace(/400/g,swidth).replace(/http:/g,"https:") : null;
        }

        if(!medianSalesPriceData && !newListingsData && !homesForSaleData) return null;

        return(
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className={graphYears && graphYears === "1" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "1"})}>1 Year</div>
                    <div className={graphYears && graphYears === "3" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "3"})}>3 Years</div>
                    <div className={graphYears && graphYears === "5" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "5"})}>5 Years</div>
                    <div className={graphYears && graphYears === "max" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "max"})}>Max Years</div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="display-bk mg-top-20">
                                <div className="mg-topbtm-15 display-bk" dangerouslySetInnerHTML={{ __html: medianSalesPriceData }}></div>
                                <div className="mg-topbtm-15 display-bk" dangerouslySetInnerHTML={{ __html: newListingsData }}></div>
                                <div className="mg-topbtm-15 display-bk" dangerouslySetInnerHTML={{ __html: homesForSaleData }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}